module.exports = __webpack_public_path__ + "img/adress.0a2e8b07.png";